import * as mutation from "./mutation-types";
import * as action from "./action-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import * as lcMutation from "@/store/levy-collections/mutation-types";
import * as lcpMutation from "@/store/levy-collection-providers/mutation-types";
import axios from "axios";
import { deepCopyAxiosException } from "@/store/helpers";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";

export const actions = {
  async [action.VIEW]({ commit }, levyCollectionId) {
    commit(mutation.VIEW_STARTED, levyCollectionId);
    try {
      const { data } = await axios.get(`/api/levy-collections/${levyCollectionId}/risk-factors`);
      commit(mutation.VIEW_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.VIEW_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.EDIT_GET]({ commit }, { levyCollectionId, riskFactorId }) {
    commit(mutation.EDIT_GET_STARTED, { levyCollectionId, riskFactorId });
    try {
      const url = `/api/levy-collections/${levyCollectionId}/risk-factors/${riskFactorId}`;
      const { data } = await axios.get(url);
      commit(mutation.EDIT_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.EDIT_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.EDIT_SAVE]({ state, commit }) {
    commit(mutation.EDIT_SAVE_STARTED);
    try {
      let result = await axios.put(
        `/api/levy-collections/${state.edit.levyCollectionId}/risk-factors/${state.edit.riskFactorId}`,
        state.edit.data
      );
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(lcMutation.STATE_UNLOAD);
      commit(lcpMutation.STATE_UNLOAD);
      commit(mutation.EDIT_SAVE_SUCCEEDED, result.data);
      commit(SHOW_NOTIFICATION, "Levy collection risk factor updated.");
      return true;
    } catch (e) {
      commit(mutation.EDIT_SAVE_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.CREATE]({ state, commit }, levyCollectionId) {
    commit(mutation.CREATE_STARTED);
    try {
      let result = await axios.post(`/api/levy-collections/${levyCollectionId}/risk-factors`, state.create.data);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(lcMutation.STATE_UNLOAD);
      commit(lcpMutation.STATE_UNLOAD);
      commit(mutation.CREATE_SUCCEEDED, result.data);
      commit(SHOW_NOTIFICATION, "Levy collection risk factor created.");
      return true;
    } catch (e) {
      commit(mutation.CREATE_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.DELETE]({ commit }, { levyCollectionId, riskFactorId }) {
    commit(mutation.DELETE_STARTED);
    try {
      let result = await axios.delete(`/api/levy-collections/${levyCollectionId}/risk-factors/${riskFactorId}`);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(lcMutation.STATE_UNLOAD);
      commit(lcpMutation.STATE_UNLOAD);
      commit(mutation.DELETE_SUCCEEDED, result.data);
      commit(SHOW_NOTIFICATION, "Risk factor range deleted.");
      return true;
    } catch (e) {
      commit(mutation.DELETE_FAILED, deepCopyAxiosException(e));
      return false;
    }
  }
};
